import { useEffect, useState } from 'react';

import { CheckboxContainer, Input, Label } from './styles';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
	label?: string;
	name: string;
	checked?: boolean;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	ref?: React.Ref<HTMLInputElement>;
	fontSize?: string;
	gap?: string;
}

const Checkbox = ({
	label,
	name,
	checked,
	onChange,
	disabled = false,
	ref,
	fontSize,
	gap,
}: CheckboxProps) => {
	const [checkedState, setCheckedState] = useState(checked);

	const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCheckedState(event.target.checked);
		onChange(event);
	};

	// Sincronizar estado interno con la prop `checked`
	useEffect(() => {
		setCheckedState(checked);
	}, [checked]);

	return (
		<CheckboxContainer gap={gap}>
			<Input
				ref={ref}
				checked={checkedState}
				disabled={disabled}
				id={name}
				name={name}
				onChange={handleInputChange}
				type="checkbox"
			/>
			{label && (
				<Label htmlFor={name} fontSize={fontSize}>
					{label}
				</Label>
			)}
		</CheckboxContainer>
	);
};

export { Checkbox };
